import { Record as ImmutableRecord } from 'immutable';
export default ImmutableRecord({
  name: null,
  type: null
}, 'ChannelDetails');